"use client";

import { c as _c } from "react/compiler-runtime";
import type { AdvancedMegaMenuNavIcon, NavIconPosition } from "@multi-tenant-cms/types/menu";
import type { CSSProperties, ReactNode } from "react";
import { sanitizeIconifySvgMarkup } from "./iconifySvg";
export function resolveNavIconPosition(icon: AdvancedMegaMenuNavIcon | undefined, defaultPosition: NavIconPosition): NavIconPosition {
  const p = icon?.iconPosition;
  return p === "left" || p === "right" ? p : defaultPosition;
}

/** Sanitized inline SVG; honors picker `color` / `sizePx` when stored. */
export function NavIconSpan(t0) {
  const $ = _c(25);
  const {
    icon,
    className
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon?.svgMarkup?.trim() ? sanitizeIconifySvgMarkup(icon.svgMarkup) : null;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safe = t1;
  if (!(safe && icon)) {
    return null;
  }
  const sizeRaw = icon.sizePx;
  let t2;
  if ($[2] !== sizeRaw) {
    t2 = typeof sizeRaw === "number" && Number.isFinite(sizeRaw) && sizeRaw > 0;
    $[2] = sizeRaw;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sized = t2;
  let t3;
  if ($[4] !== icon.color) {
    t3 = icon.color?.trim();
    $[4] = icon.color;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const color = t3;
  let t4;
  if ($[6] !== sizeRaw || $[7] !== sized) {
    t4 = sized ? {
      width: sizeRaw,
      height: sizeRaw
    } : {};
    $[6] = sizeRaw;
    $[7] = sized;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== color) {
    t5 = color ? {
      color
    } : {};
    $[9] = color;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      ...t4,
      ...t5
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const style = t6;
  let t7;
  if ($[14] !== safe) {
    t7 = {
      __html: safe
    };
    $[14] = safe;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== sized) {
    t8 = sized ? {
      "data-ghh-nav-icon-sized": ""
    } : {};
    $[16] = sized;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== style) {
    t9 = Object.keys(style).length > 0 ? style : undefined;
    $[18] = style;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== className || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <span aria-hidden={true} className={className} dangerouslySetInnerHTML={t7} {...t8} style={t9} />;
    $[20] = className;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}

/** Icon + label cluster; label-first in DOM when icon is on the right. */
export function NavIconLabel(t0) {
  const $ = _c(10);
  const {
    className,
    icon,
    iconClassName,
    iconPosition: t1,
    children
  } = t0;
  const iconPosition = t1 === undefined ? "left" : t1;
  let t2;
  if ($[0] !== icon || $[1] !== iconClassName) {
    t2 = <NavIconSpan className={iconClassName} icon={icon} />;
    $[0] = icon;
    $[1] = iconClassName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const iconEl = t2;
  let t3;
  if ($[3] !== children || $[4] !== iconEl || $[5] !== iconPosition) {
    t3 = iconPosition === "right" ? <>{children}{iconEl}</> : <>{iconEl}{children}</>;
    $[3] = children;
    $[4] = iconEl;
    $[5] = iconPosition;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== t3) {
    t4 = <span className={className}>{t3}</span>;
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}